// @flow

export const CARD_LOGS_UPDATE_REQUEST = 'Card/CARD_LOGS_UPDATE_REQUEST';
export const CARD_LOGS_UPDATE_SUCCESS = 'Card/CARD_LOGS_UPDATE_SUCCESS';
export const CARD_LOGS_UPDATE_FAILURE = 'Card/CARD_LOGS_UPDATE_FAILURE';
